<template>
  <div tabindex="0" class="img_box"  @click="goTo">
    <img
      :src="data.bannerImg"
      :alt="data.imgAltText"
    />
    <!-- <p>exhUrlTypeCd: {{ data.exhUrlTypeCd }}</p>
    <p>exhBannerSeq: {{ data.exhBannerSeq }}</p>
    <p>exhUrlPath: {{ data.exhUrlPath }}</p>
    <p>editUser: {{ data.editUser }}</p>
    <p>eventTypeCd: {{ data.eventTypeCd }}</p>
    <p>bannerName: {{ data.bannerName }}</p>
    <p>regDate: {{ data.regDate }}</p>
    <p>bannerPosCd: {{ data.bannerPosCd }}</p>
    <p>sort: {{ data.sort }}</p>
    <p>displyaYn: {{ data.displyaYn }}</p>
    <p>exhUrlStDate: {{ data.exhUrlStDate }}</p>
    <p>regUser: {{ data.regUser }}</p>
    <p>editDate: {{ data.editDate }}</p>
    <p>bgColor: {{ data.bgColor }}</p>
    <p>imgAltText: {{ data.imgAltText }}</p>
    <p>bannerTypeCd: {{ data.bannerTypeCd }}</p>
    <p>eventSeq: {{ data.eventSeq }}</p>
    <p>exhUrlEdDate: {{ data.exhUrlEdDate }}</p>
    <p>useYn: {{ data.useYn }}</p>
    <p>bannerImg: {{ data.bannerImg }}</p> -->
  </div>
</template>

<script>
export default {
  props: {
    /**
     * @example
     * {
        exhUrlTypeCd: null,
        exhBannerSeq: 259,
        exhUrlPath: null,
        editUser: 49,
        eventTypeCd: 'NORMAL',
        bannerName: '8월 구매 할수록 리워드!!',
        regDate: '2021-07-29T01:18:39.470+0000',
        bannerPosCd: 'GNB',
        sort: 1,
        displyaYn: 'Y',
        exhUrlStDate: '2021-07-28T15:00:00.000+0000',
        regUser: 49,
        editDate: '2021-07-29T01:18:49.150+0000',
        bgColor: '',
        imgAltText: '8월 구매 할수록 리워드!!',
        bannerTypeCd: 'EVENT',
        eventSeq: 282,
        exhUrlEdDate: '2021-08-31T14:00:00.000+0000',
        useYn: 'Y',
        bannerImg: 'https://biz.giftishow.com/files/BBS_20210729101839434.jpg',
      }
     */
    data: {
      type: Object,
      required: true,
      default: () => {},
    },
  },

  methods: {
    goTo() {
      const { exhUrlPath, bannerTypeCd, eventTypeCd, exhUrlTypeCd, eventSeq } = this.data;

      if (bannerTypeCd === 'URL') {
        if (exhUrlTypeCd === 'IN') {
          document.location.href = exhUrlPath;
          return;
        }
        window.open(exhUrlPath, '_blank');
        return;
      }
      if (bannerTypeCd === 'EVENT') {
        if (eventTypeCd === 'SURVEY') {
          this.$router.push({ name: 'eventreport', query: { eventSeq } });
          return;
        }
        this.$router.push({ name: 'eventview', query: { eventSeq } });
      }
    },
  },
};
</script>

<style>
</style>